import React from 'react'
import { IconWrapper } from '../IconWrapper'
import type { IconWrapperProps } from '../IconWrapper'

export const EcommMicrophoneIcon = React.forwardRef<SVGSVGElement, IconWrapperProps>(
  (props, forwardedRef) => {
    return (
      <IconWrapper {...props}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
          ref={forwardedRef}
        >
          <path
            d="M14.5 13V5.7625C14.5 4.51295 13.487 3.5 12.2375 3.5H12C10.6193 3.5 9.5 4.61929 9.5 6V13C9.5 14.3807 10.6193 15.5 12 15.5C13.3807 15.5 14.5 14.3807 14.5 13ZM12 17C9.79086 17 8 15.2091 8 13V6C8 3.79086 9.79086 2 12 2H12.2375C14.3155 2 16 3.68453 16 5.7625V13C16 15.2091 14.2091 17 12 17Z"
            fill="#222"
            fillRule="evenodd"
            clipRule="evenodd"
          />
          <path
            d="M6 12.25C6.41421 12.25 6.75 12.5858 6.75 13C6.75 15.8995 9.1005 18.25 12 18.25C14.8995 18.25 17.25 15.8995 17.25 13C17.25 12.5858 17.5858 12.25 18 12.25C18.4142 12.25 18.75 12.5858 18.75 13C18.75 16.7279 15.7279 19.75 12 19.75C8.27208 19.75 5.25 16.7279 5.25 13C5.25 12.5858 5.58579 12.25 6 12.25Z"
            fill="#222"
            fillRule="evenodd"
            clipRule="evenodd"
          />
          <path
            d="M12 18.25C12.4142 18.25 12.75 18.5858 12.75 19V21C12.75 21.4142 12.4142 21.75 12 21.75C11.5858 21.75 11.25 21.4142 11.25 21V19C11.25 18.5858 11.5858 18.25 12 18.25Z"
            fill="#222"
            fillRule="evenodd"
            clipRule="evenodd"
          />
          <path
            d="M15.75 21C15.75 21.4142 15.4142 21.75 15 21.75H9C8.58579 21.75 8.25 21.4142 8.25 21C8.25 20.5858 8.58579 20.25 9 20.25H15C15.4142 20.25 15.75 20.5858 15.75 21Z"
            fill="#222"
            fillRule="evenodd"
            clipRule="evenodd"
          />
        </svg>
      </IconWrapper>
    )
  },
)
